<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <rotas-table-historico :rotas="rotas" :motoristas="motoristas" :map="map" :alocarMotorista="setMotoristas" :reOrdenar="setOrdem" :salvarRotas="salvarUnico" />
      
        <div class="dataTable-bottom">
            <div class="dataTable-info">
              Mostrando {{ current_page * 10 + 1 }} até {{ Math.min((current_page + 1) * 10, total_count) }} de {{ total_count }} pedidos
            </div>
            <nav class="dataTable-pagination">
              <ul class="dataTable-pagination-list"> 
                <!-- Botão para voltar à página anterior -->
                <li @click="getPaginas(Math.max((current_page - 1) * 10, 0))" 
                    class="pager" 
                    :class="{ disabled: current_page === 0 }">
                  <a href="#">‹</a>
                </li>

                <!-- Paginação de números -->
                <li v-for="page in total_pages" :key="page" 
                    @click="getPaginas((page - 1) * 10)" 
                    :class="{ active: current_page === (page - 1) }">
                  <a href="#">{{ page }}</a>
                </li>

                <!-- Botão para avançar para a próxima página -->
                <li @click="getPaginas(Math.min((current_page + 1) * 10, (total_pages - 1) * 10))" 
                    class="pager"
                    :class="{ disabled: current_page === total_pages - 1 }">
                  <a href="#">›</a>
                </li>
              </ul>
            </nav>
        </div>

      </div>
    </div>
  </div>
</template>
<style>
   .custom-marker {
      background-color: white;
      border-radius: 50%;
      padding: 10px;
      text-align: center;
      border: 2px solid black;
      width: 50px;
      height: 50px;
    }

    .custom-marker img {
      width: 100%;
      border-radius: 50%;
    }
</style>
<script>

import GoogleMapsApiLoader from 'google-maps-api-loader'

import { MarkerClusterer } from "@googlemaps/markerclusterer";

import { defineComponent, ref , toRaw  } from 'vue';

import RotasTableHistorico from "./components/RotasTableHistorico.vue";

import ArgonButton from "@/components/ArgonButton.vue";

import fintailapi from "../api";

export default defineComponent({
  name: "tables",
  components: {
    RotasTableHistorico,
    ArgonButton
  },
  data() {
    return {
      map: null,
      google: null,
      rotas: [],
      motoristas:[],
      current_page:0,
      offset:0,
      current_offset:0,
      total_count: 0,
      total_pages: 0,
    };
  },
  async mounted() {
    
    this.initializeMap()

  },
  methods: {

    initializeMap() {

      this.getRotas(this.current_offset)

    },

    async goRefresh(){

            this.no_show=true;
            
      const googleMapApi = await GoogleMapsApiLoader({
        apiKey: process.env.VUE_APP_MAPS_APIKEY,
        v:'beta'
      })

      this.google = googleMapApi;

      this.initializeMap()

    },
    getRota(id) {

      fintailapi
      .get(`/rotas/${id}`)
      .then((response) => {

          const colors = ['#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF']; // Exemplo de cores

          this.current_page = 0;

          let rota = response.data;
          this.total_pages = response.data.count / 10

          const { Polyline, Marker } = this.google.maps;

          const decodedPoints = rota.rota.Caminho.flatMap(segment => [
            { lat: segment.startPoint.coordinates[1], lng: segment.startPoint.coordinates[0] },
            { lat: segment.endPoint.coordinates[1], lng: segment.endPoint.coordinates[0] }
          ]);

          let routePath = new Polyline({
            path: decodedPoints,
            geodesic: true,
            strokeColor: colors[0],
            strokeOpacity: 0.4,
            strokeWeight: 8,
          });

          routePath.setMap(this.map);

          for(let pedido of rota.rota.Pedidos){

              const local = {
                  id: pedido.id_pedido,
                  position: { lat: parseFloat(pedido.latitude), lng:  parseFloat(pedido.longitude) }
              };

              new Marker({
                position: local.position,
                marker: local,
                map: this.map,
                icon: 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png'
              });

          }

          new Marker({
            position: { lat: rota.rota.Operacao.latitude, lng:  rota.rota.Operacao.longitude},
            map:  this.map,
            title: "Centro",
            icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png' // Ícone do marcador
          });


      })
      .catch((error) => {

        //this.isOpenRef = true;

      })

    },
    getPaginas(offset) {

        if (this.total_count > 0 && (offset < 0 || offset >= this.total_count)) return; // Impede valores inválidos
        
        this.current_offset = offset;

        this.getRotas(offset);       

    },
    getRotas(offset) {

        fintailapi
        .post(`/rotas/historico?offset=${offset}&limit=10`,{})
        .then(async(response) => {


            this.getMotoristas();

            this.current_page = 0;

            let local_rotas = response.data.rows;

            for(let rota of local_rotas){

              rota.Pedidos.sort((a, b) => a.ordem - b.ordem);

            }


            this.rotas = local_rotas;

            this.current_page = offset / 10; // Atualiza a página com base no offset
            this.total_count = response.data.count;
            this.total_pages = Math.ceil(response.data.count / 10);


/*
            const { Polyline, Marker } = this.google.maps;
            const { AdvancedMarkerElement, PinElement } = await this.google.maps.importLibrary("marker");
*/
          
            const colors = [
              '#FF0000', '#0000FF', '#00FF00', '#FFA500', '#800080', '#00FFFF',
              '#FFD700', '#FF69B4', '#8A2BE2', '#FF4500', '#7FFF00', '#DC143C',
              '#00BFFF', '#9932CC', '#FF1493', '#FF6347', '#2E8B57', '#FF7F50',
              '#6A5ACD', '#20B2AA', '#B22222', '#32CD32', '#BA55D3', '#4682B4',
              '#808000', '#DAA520', '#B0E0E6', '#A52A2A', '#8B4513', '#5F9EA0',
              '#D2691E', '#FF00FF', '#F08080', '#C71585', '#000080', '#008080',
              '#9ACD32', '#FFDAB9', '#708090', '#DDA0DD', '#EEE8AA', '#AFEEEE'
            ];
            
            let key = 0;
/*
            for(let rota of this.rotas){

              this.rotas[key].color = colors[key % colors.length]

                const decodedPoints = rota.Caminho.flatMap(segment => [
                    { lat: segment.startPoint.coordinates[1], lng: segment.startPoint.coordinates[0] },
                    { lat: segment.endPoint.coordinates[1], lng: segment.endPoint.coordinates[0] }
                ]);


                this.rotas[key].distance = (rota.Caminho.reduce((acc, item) => acc + item.distance, 0)).toFixed(2);

                
                let routePath = new Polyline({
                    path: decodedPoints,
                    geodesic: true,
                    strokeColor: colors[key % colors.length],
                    strokeOpacity: 0.6,
                    strokeWeight: 4
                });

               // routePath.setMap(this.map);




                
                let all_markers = []
                let sequencia = 0;



                let ce = new Marker({
                    position: { lat: rota.Operacao.latitude, lng: rota.Operacao.longitude },
                    title: "Centro",
                    icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                })
                all_markers.push(ce)



                for(let pedido of rota.Pedidos){

                    const local = {
                        id: pedido.id_pedido,
                        position: { lat: parseFloat(pedido.latitude), lng:  parseFloat(pedido.longitude) }
                    };


                  
                    //try {






                      let marker =  new Marker({
                         title: pedido.numero_pedido,

                        position: local.position,
                        // adjust zIndex to be above other markers
                        zIndex: Number(this.google.maps.Marker.MAX_ZINDEX) + pedido.ordem,
                        icon: {
                            url: 'data:image/svg+xml;utf-8,' + encodeURIComponent(`
                              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 1024 1024">
                          <path d="M512 85.333333c-164.949333 0-298.666667 133.738667-298.666667 298.666667
                                  0 164.949333 298.666667 554.666667 298.666667 554.666667s298.666667-389.717333
                                  298.666667-554.666667c0-164.928-133.717333-298.666667-298.666667-298.666667z
                                  m0 448a149.333333 149.333333 0 1 1 0-298.666666 149.333333 149.333333 0 0 1 0 298.666666z"
                                fill="${colors[key % colors.length]}" />
                          <text x="512" y="420" text-anchor="middle" alignment-baseline="middle"
                                font-size="320"  fill="#ffffff">${pedido.ordem}</text>
                        </svg>
                            `),


                        }
                      })

                      all_markers.push(marker);

                  

                    

                    sequencia++
                }



                ce = new Marker({
                    position: { lat: rota.Operacao.latitude, lng: rota.Operacao.longitude },
                    title: "Centro",
                    icon: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png'
                })
                all_markers.push(ce)

                
                //
                const cluster =  new MarkerClusterer({ map: this.map, markers: all_markers });

                rota._polyline = routePath;
                rota._cluster  = cluster;
                rota._markers  = all_markers;
                rota.visible   = true;


                key++

            }
         
            */



        })
        .catch((error) => {
          console.log(error)
          //this.isOpenRef = true;

        })

    },
    getMotoristas() {

          fintailapi
          .get(`/transportadores`)
          .then(async(response) => {

              this.motoristas = response.data.rows;

          })
          .catch((error) => {

            console.log(error)
            //this.isOpenRef = true;

          })

    },

    setMotoristas(id_veiculo, id_rota, id_transportador){

      fintailapi
      .post(`/transportadores/alocar/${id_veiculo}/${id_rota}/${id_transportador}`,{})
      .then((response) => {
          this.getRotas(this.current_offset)
      });

    },

    setOrdem(pedido){   
      
      this.no_show=false
      
      fintailapi
      .patch(`/pedidos/reordenar/${pedido.id_pedido}`, pedido)
      .then((response) => {
          //this.getRotas()

                fintailapi
                .get(`/rotas/processar/${pedido.id_rota}`)
                .then((response) => {
                    
                });

      });

    },
    salvarUnico(rota){
     

      let update = { fixa: rota.fixa, finalizado: rota.finalizado   }

      fintailapi
      .put(`/rotas/${rota.id}`, update)
      .then((response) => {

        //this.getRotas()

      });

    }
    
  },
 
  created() {

  },

});


</script>
